export const tmsRequestMethod = () => 'get'

export const tmsRequestParams = (type, { sendAsOwn = false } = {}) => (
  type === 'candidate'
    ? { send_as_own: Boolean(sendAsOwn) }
    : {}
)
